import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["content", "icon"];

    connect() {
        console.log("Connected to Toggle Content Controller!")
    }

    toggle(){
        $(this.contentTarget).toggleClass('hidden')
        if(this.iconTarget){
            $(this.iconTargets).toggleClass('hidden')
        }
    }

}